module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "challenge-mode",
    class: {
      'is-correct': _vm.isCorrect, 'is-active': _vm.target !== null
    }
  }, [(_vm.target === null) ? _c('div', {
    staticClass: "challenge-idle"
  }, [_c('button', {
    staticClass: "challenge-start",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.startChallenge
    }
  }, [_c('svg', {
    staticClass: "challenge-start__glyph",
    attrs: {
      "viewBox": "0 0 22 14",
      "aria-hidden": "true"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "6",
      "cy": "3",
      "r": "1.6",
      "fill": "currentColor"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "cx": "16",
      "cy": "3",
      "r": "1.6",
      "fill": "currentColor"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "3",
      "y": "9",
      "width": "16",
      "height": "2.4",
      "rx": "0.4",
      "fill": "currentColor"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "challenge-start__label"
  }, [_vm._v(_vm._s(_vm.t.start))])])]) : _c('div', {
    staticClass: "challenge-panel"
  }, [_c('p', {
    staticClass: "challenge-prompt"
  }, [_vm._v(_vm._s(_vm.t.compose))]), _vm._v(" "), _c('p', {
    staticClass: "challenge-target",
    class: {
      'is-correct': _vm.isCorrect
    }
  }, [_vm._v(_vm._s(_vm.target))]), _vm._v(" "), (_vm.isCorrect) ? _c('div', {
    staticClass: "challenge-feedback challenge-feedback--success"
  }, [_c('p', {
    staticClass: "challenge-correct"
  }, [_vm._v(_vm._s(_vm.t.correct))]), _vm._v(" "), _c('div', {
    staticClass: "challenge-actions"
  }, [_c('button', {
    staticClass: "challenge-link",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.nextChallenge
    }
  }, [_vm._v(_vm._s(_vm.t.next))]), _vm._v(" "), _c('span', {
    staticClass: "challenge-link__sep"
  }, [_vm._v("·")]), _vm._v(" "), _c('button', {
    staticClass: "challenge-link",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v(_vm._s(_vm.t.stop))])])]) : _c('div', {
    staticClass: "challenge-feedback"
  }, [_c('p', {
    staticClass: "challenge-current"
  }, [_c('span', {
    staticClass: "challenge-current__label"
  }, [_vm._v(_vm._s(_vm.t.current))]), _vm._v(" "), _c('span', {
    staticClass: "challenge-current__value"
  }, [_vm._v(_vm._s(_vm.current))])]), _vm._v(" "), _c('p', {
    staticClass: "challenge-diff",
    class: _vm.diffSeverityClass
  }, [_c('span', {
    staticClass: "challenge-diff__label"
  }, [_vm._v(_vm._s(_vm.diffLabel))]), _vm._v(" "), _c('span', {
    staticClass: "challenge-diff__value"
  }, [_vm._v(_vm._s(_vm.diff))])]), _vm._v(" "), _c('div', {
    staticClass: "challenge-actions"
  }, [_c('button', {
    staticClass: "challenge-link",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.nextChallenge
    }
  }, [_vm._v(_vm._s(_vm.t.next))]), _vm._v(" "), _c('span', {
    staticClass: "challenge-link__sep"
  }, [_vm._v("·")]), _vm._v(" "), _c('button', {
    staticClass: "challenge-link",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v(_vm._s(_vm.t.stop))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4ce5e4d4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChallengeMode.vue
// module id = 63
// module chunks = 2